<template>
  <div class="row ml-1">
    <div class="ml-5">
      <div v-for="option in options" :key="option.Id">
        <div class="name">{{ option.name }}</div>
        <div class="shade-input">
          <div
            v-if="inputData[option.name] != null"
            style="padding: 4px; display: inline-flex; overflow: hidden; flex-wrap: wrap"
          >
            <div
              class="shade"
              v-for="colors in inputData[option.name]"
              :key="colors.value"
              style="display: flex; overflow: hidden"
            >
              <input
                class="shade-color"
                type="color"
                id="favcolor"
                name="favcolor"
                :value="colors.value"
                :title="colors.name"
                :disabled="colors.isUsed || !isActive"
                @input="$emit('editShade', handleEmit($event.target), option.name, colors.value, colors.name)"
                :aria-label="'favColor'"
              />
              <div class="shade-name">{{ colors.name }}</div>
              <button
                v-if="!colors.isUsed && isActive"
                class="close k-icon k-i-close"
                @click="$emit('handleRemoveShade', option.name, colors.value)"
              ></button>
            </div>
            <PopupComp
              v-if="isActive"
              :option="option"
              @handleshadeAddition="handleShade"
              @Input="handleEventName"
              @InputValue="handleEventValue"
            ></PopupComp>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button class="btn btn-sm btn-primary" type="submit" @click="$emit('handleUpdate')">
            {{ $t("shadingComp.update") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import PopupComp from "./Popup.vue";

export default defineComponent({
  name: "ShadingComponent",
  props: {
    options: {
      type: Array as () => any[]
    },
    inputData: {
      type: Object,
      required: true
    },
    isActive: {
      type: Boolean
    }
  },
  emits: ["editShade", "handleRemoveShade", "handleUpdate", "handleAddShade", "getShadeName", "getShadeValue"],
  data() {
    return {
      color: Object.keys(this.inputData).map((key, index) => ({
        id: index + 1,
        name: key
      }))
    };
  },
  components: {
    PopupComp
  },
  methods: {
    handleEmit(target: EventTarget | null) {
      return (target as HTMLInputElement).value;
    },
    handleShade(category: any) {
      this.$emit("handleAddShade", category);
    },
    handleEventName(event: Event) {
      this.$emit("getShadeName", event);
    },
    handleEventValue(event: Event) {
      this.$emit("getShadeValue", event);
    }
  }
});
</script>
<style scoped>
body {
  font-family: Arial, Helvetica, sans-serif;
}
.name {
  width: 50px;
  position: relative;
  top: 15px;
  font-size: 14px;
  color: 646262;
  font-weight: bold;
}
.shade-input {
  width: 38rem;
  min-height: 3.2rem;
  border: 1px solid #9fa0a1;
  margin-left: 8.5rem;
  margin-top: -1rem;
  display: table;
  border-radius: 6px;
}
.shade {
  display: flex;
  align-items: center;
  padding: 4px;
  border: 1px solid #9fa0a1;
  margin: 2px;
  border-radius: 6px;
}
.shade-name {
  margin-left: 5px;
}
.shade-color {
  width: 24px;
  height: 27px;
  border: none;
}
.shade-color:hover,
.close:hover {
  cursor: pointer;
}
.close {
  padding: 4px !important;
  font-size: 18px !important;
  font-weight: bold;
}
.btn-primary {
  background-color: #0054a6;
}
</style>
